import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'

import { CellRenderer } from '@/utils/table'

import { LinkWithTracker } from '@/components/LinkWithTracker'

export const CustomStatisticCellRenderer = ({ row, col, redirectLink }) => {
  const value = row.getValue()
  const originalRowData = row?.row?.original || {}

  if (col?.id === 'wilayah') {
    if (
      typeof originalRowData?.meta === 'object' &&
      originalRowData?.meta['districtId']
    ) {
      return (
        <LinkWithTracker
          href={redirectLink}
          replace={true}
          prefetch={false}
          className="hover:underline"
          data-type="wilayah"
          data-clickable="true"
        >
          <Link underline={false} as="p">
            {value}
          </Link>
        </LinkWithTracker>
      )
    }

    return (
      <div data-type="wilayah">
        <Text>{value}</Text>
      </div>
    )
  }

  return <CellRenderer getValue={row.getValue} />
}
